export const BACK_IN_STOCK_SUBSCRIPTION = 'backinstock';
export const COMING_SOON_SUBSCRIPTION = 'comingsoon';
